import { Formik, ErrorMessage } from 'formik';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { updateProfileValues } from '../../utils/initialValues';
import { validateProfileUpdate } from '../../utils/validateValues';

const ProfileForm = ({ data }) => {
  const history = useNavigate();
  const [coverImage, setCoverImage] = useState('');
  let message;

  const successNotification = (message) => toast.success(message);
  const errorNotification = (message) => toast.error(message);

  const initialValues = updateProfileValues(data);
  const validationSchema = validateProfileUpdate();

  const handleCoverImageChange = (e) => {
    setCoverImage(e.target.files[0]);
  };

  const handleFormSubmit = (values) => {
    const formData = new FormData();
    formData.append('fName', values.fName);
    formData.append('lName', values.lName);
    formData.append('gender', values.gender);
    formData.append('dob', values.dob);
    formData.append('maritalStatus', values.maritalStatus);
    formData.append('phone', values.phone);
    formData.append('address', values.address);
    formData.append('city', values.city);
    formData.append('occupation', values.occupation);
    formData.append('currentEmployer', values.currentEmployer);
    formData.append('employerAddress', values.employerAddress);
    formData.append('nextOfKin', values.nextOfKin);
    formData.append('nextofKinAddress', values.nextofKinAddress);
    formData.append('coverImage', coverImage);

    console.log(...formData);

    axios
      .put(`${process.env.REACT_APP_API_URL}/marketers/update-profile`, formData)
      .then((res) => {
        message = res.data.message;
        if (res.status === 200) {
          successNotification(message);
          console.log(message);
          setTimeout(() => history('/profile'), 2000);
        } else {
          errorNotification(message);
          console.log('Failed');
        }
      })
      .catch((err) => {
        console.log(err);
        errorNotification(err);
      });
  };

  return (
    <div className="profileForm">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      {data && (
        <Formik
          onSubmit={handleFormSubmit}
          initialValues={initialValues}
          validationSchema={validationSchema}
        >
          {({ values, errors, touched, handleBlur, handleChange, handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <div style={{ marginTop: '20px', marginBottom: '0px', fontWeight: 'bold' }}>
                User Information
              </div>
              <div>
                <label htmlFor="fName">First Name</label>
                <input
                  type="text"
                  id="fName"
                  name="fName"
                  value={values.fName}
                  error={!!touched.fName && !!errors.fName}
                  helpertext={touched.fName && errors.fName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter your first name"
                />
                <ErrorMessage name="fName" component="span" className="error" />
              </div>
              <div>
                <label htmlFor="lName">Last Name</label>
                <input
                  type="text"
                  id="lName"
                  name="lName"
                  value={values.lName}
                  error={!!touched.lName && !!errors.lName}
                  helpertext={touched.lName && errors.lName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter your last name"
                />
                <ErrorMessage name="lName" component="span" className="error" />
              </div>
              <div>
                <label htmlFor="gender">Gender</label>
                <select
                  name="gender"
                  id="gender"
                  value={values.gender}
                  onChange={handleChange}
                  onBlur={handleBlur}
                >
                  <option value="">Select gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
                <ErrorMessage name="gender" component="span" className="error" />
              </div>
              <div>
                <label htmlFor="city">Date of Birth</label>
                <input
                  type="date"
                  id="dob"
                  name="dob"
                  value={values.dob}
                  error={!!touched.dob && !!errors.dob}
                  helpertext={touched.dob && errors.dob}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  required
                />
                <ErrorMessage name="dob" component="span" className="error" />
              </div>
              <div>
                <label htmlFor="maritalStatus">Marital Status</label>
                <select
                  name="maritalStatus"
                  id="maritalStatus"
                  value={values.maritalStatus}
                  onChange={handleChange}
                  onBlur={handleBlur}
                >
                  <option value="">Select marital status</option>
                  <option value="Single">Single</option>
                  <option value="In a relationship">In a relationship</option>
                  <option value="Married">Married</option>
                  <option value="Divorced">Divorced</option>
                  <option value="Widow">Widow</option>
                </select>
                <ErrorMessage name="maritalStatus" component="span" className="error" />
              </div>

              <div style={{ marginTop: '20px', marginBottom: '0px', fontWeight: 'bold' }}>
                Contact Information
              </div>
              <div>
                <label htmlFor="phone">Phone Number</label>
                <input
                  type="text"
                  id="phone"
                  name="phone"
                  value={values.phone}
                  error={!!touched.phone && !!errors.phone}
                  helpertext={touched.phone && errors.phone}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter your first name"
                />
                <ErrorMessage name="phone" component="span" className="error" />
              </div>
              <div>
                <label htmlFor="address">Contact Address</label>
                <textarea
                  id="address"
                  name="address"
                  cols="30"
                  rows="1"
                  value={values.address}
                  onChange={handleChange}
                  onBlur={handleBlur}
                ></textarea>
                <ErrorMessage name="address" component="span" className="error" />
              </div>
              <div>
                <label htmlFor="city">City of Residence</label>
                <input
                  type="text"
                  id="city"
                  name="city"
                  value={values.city}
                  error={!!touched.city && !!errors.city}
                  helpertext={touched.city && errors.city}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Which city do you live?"
                />
                <ErrorMessage name="city" component="span" className="error" />
              </div>

              <div style={{ marginTop: '20px', marginBottom: '0px', fontWeight: 'bold' }}>
                Occupation Information
              </div>
              <div>
                <label htmlFor="occupation">Occupation</label>
                <input
                  type="text"
                  id="occupation"
                  name="occupation"
                  value={values.occupation}
                  error={!!touched.occupation && !!errors.occupation}
                  helpertext={touched.occupation && errors.occupation}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="What do you do?"
                />
                <ErrorMessage name="occupation" component="span" className="error" />
              </div>
              <div>
                <label htmlFor="city">Current Employer</label>
                <input
                  type="text"
                  id="currentEmployer"
                  name="currentEmployer"
                  value={values.currentEmployer}
                  error={!!touched.currentEmployer && !!errors.currentEmployer}
                  helpertext={touched.currentEmployer && errors.currentEmployer}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Who is your current employer?"
                />
                <ErrorMessage name="currentEmployer" component="span" className="error" />
              </div>
              <div>
                <label htmlFor="city">Address of Employment</label>
                <input
                  type="text"
                  id="employerAddress"
                  name="employerAddress"
                  value={values.employerAddress}
                  error={!!touched.employerAddress && !!errors.employerAddress}
                  helpertext={touched.employerAddress && errors.employerAddress}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="At where are you employed?"
                />
                <ErrorMessage name="employerAddress" component="span" className="error" />
              </div>

              <div style={{ marginTop: '20px', marginBottom: '0px', fontWeight: 'bold' }}>
                Next of Kin Information
              </div>
              <div>
                <label htmlFor="nextOfKin">Next of Kin</label>
                <input
                  type="text"
                  id="nextOfKin"
                  name="nextOfKin"
                  value={values.nextOfKin}
                  error={!!touched.nextOfKin && !!errors.nextOfKin}
                  helpertext={touched.nextOfKin && errors.nextOfKin}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Next of Kin name?"
                />
                <ErrorMessage name="nextOfKin" component="span" className="error" />
              </div>
              <div>
                <label htmlFor="nextofKinAddress">Next of Kin Address</label>
                <input
                  type="text"
                  id="nextofKinAddress"
                  name="nextofKinAddress"
                  value={values.nextofKinAddress}
                  error={!!touched.nextofKinAddress && !!errors.nextofKinAddress}
                  helpertext={touched.nextofKinAddress && errors.nextofKinAddress}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Where does your Next of Kin live?"
                />
                <ErrorMessage name="nextofKinAddress" component="span" className="error" />
              </div>

              <div>
                <label htmlFor="coverImage">Profile Image</label>
                <input
                  type="file"
                  id="coverImage"
                  name="coverImage"
                  value={values.coverImage}
                  error={!!touched.coverImage && !!errors.coverImage}
                  helpertext={touched.coverImage && errors.coverImage}
                  onChange={handleCoverImageChange}
                  required
                />
              </div>

              <button type="submit">Save Profile</button>
            </form>
          )}
        </Formik>
      )}
    </div>
  );
};

export default ProfileForm;
